import { render } from "./NewOffice.vue?vue&type=template&id=0db84748&scoped=true"
import script from "./NewOffice.vue?vue&type=script&lang=js"
export * from "./NewOffice.vue?vue&type=script&lang=js"

import "./NewOffice.vue?vue&type=style&index=0&id=0db84748&lang=scss&scoped=true"

import exportComponent from "/tmp/build_195c5171/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db84748"]])

export default __exports__